<script>
export default {
  name: 'c-sector-icon',
  props: {
    sectorId: {
      type: Number,
      default: -1
    }
  },
  render(h) {
    const attrs = {
      xmlns: 'http://www.w3.org/2000/svg',
      role: 'img',
      width: '512',
      height: '512'
    };
    const children = [];
    const title =
      isNaN(Number.parseInt(this.sectorId)) || this.sectorId === 0
        ? ''
        : this.$t(`white-label.sectors.${this.sectorId}`);
    children.push(h('span', { class: 'sr-only' }, title));

    /*
     * Definitily not the best way to do this, but since "fill: currentColor" is necessary to make the icons work with dark & light themes the only other options would have been:
     * - add vue-svg-loader to webpack build, but this inlined all svgs
     * - import svg-file, this only returns the path to the icon and we cant style svgs with css if they are includes as an image
     * - create a icon font for the sector-icons, too much overhead
     * - have the icons both in dark & light variants, also too much overhead
     *
     * --> inlining them by hand was the fastest way to solve the issue
     */
    switch (this.sectorId) {
      case 50: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 352 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z'
              }
            })
          ])
        );
        break;
      }
      case 51: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 337.994 337.994' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M185.936 171.392c-4.812 5.053-14.454 9.187-21.434 9.187H12.686c-6.978 0-8.749-4.134-3.938-9.187l136.578-143.42c4.812-5.053 14.456-9.187 21.434-9.187h151.817c6.978 0 8.749 4.134 3.938 9.187l-136.579 143.42zM177.325 306.524c0 6.978-5.707 12.686-12.685 12.686H12.686C5.708 319.21 0 313.502 0 306.524v-97.913c0-6.979 5.708-12.688 12.686-12.688H164.64c6.978 0 12.685 5.709 12.685 12.688v97.913zM337.79 129.296c-.017 6.978-3.766 17.003-8.33 22.279L197.913 303.64c-4.563 5.274-8.299 3.885-8.299-3.093v-97.801c0-6.977 3.939-16.813 8.76-21.859l130.891-137.09c4.817-5.047 8.745-3.467 8.729 3.51l-.204 81.989z'
              }
            })
          ])
        );
        break;
      }
      case 52: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 420 420' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M300,240.715V155l-120,85.715V155h-30V85h-30v70H90V35H30v120H0v230h420V155L300,240.715z M160,335h-40  v-40h40V335z M230,335h-40v-40h40V335z M300,335h-40v-40h40V335z'
              }
            })
          ])
        );
        break;
      }
      case 53: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 612.002 612.002' } }, [
            h('g', { attrs: { fill: 'currentColor' } }, [
              h('path', {
                attrs: {
                  d:
                    'M437.511 174.502c5.123 5.123 13.434 5.123 18.55 0L608.158 22.399c5.123-5.123 5.123-13.427 0-18.557-5.116-5.123-13.427-5.123-18.55 0L437.511 155.945c-5.129 5.123-5.129 13.434 0 18.557z'
                }
              }),
              h('path', {
                attrs: {
                  d:
                    'M568.952 289.544l-16.681-183.418-45.792 45.792c2.663 17.002-2.525 35.002-15.625 48.101-21.771 21.771-57.075 21.778-78.846 0-21.771-21.771-21.771-57.081 0-78.852 13.099-13.099 31.086-18.281 48.082-15.625l45.805-45.805L322.47 43.055a24.451 24.451 0 00-19.482 7.058L7.152 345.949c-9.531 9.538-9.538 24.992 0 34.523l65.805 65.812 32.47-32.47 92.765 92.765-32.463 32.463 65.805 65.805c9.538 9.538 24.985 9.538 34.516 0l295.856-295.836a24.509 24.509 0 007.046-19.467z'
                }
              })
            ])
          ])
        );
        break;
      }
      case 54: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 19.25 19.25' } }, [
            h('g', { attrs: { fill: 'currentColor' } }, [
              h('path', {
                attrs: {
                  d:
                    'M19.006 2.97a1.003 1.003 0 00-.756-.345H4.431l-.195-1.164A1 1 0 003.25.625H1a1 1 0 100 2h1.403l1.86 11.164c.008.045.031.082.045.124.016.053.029.103.054.151a.982.982 0 00.12.179c.031.039.059.078.095.112a.96.96 0 00.193.13c.038.021.071.049.112.065a.97.97 0 00.367.075H16.25a1 1 0 100-2H6.097l-.166-1H17.25a1 1 0 00.99-.858l1-7a1.002 1.002 0 00-.234-.797zm-1.909 1.655l-.285 2H13.25v-2h3.847zm-4.847 0v2h-3v-2h3zm0 3v2h-3v-2h3zm-4-3v2h-3a.481.481 0 00-.148.03l-.338-2.03H8.25zm-2.986 3H8.25v2H5.597l-.333-2zm7.986 2v-2h3.418l-.285 2H13.25z'
                }
              }),
              h('circle', { attrs: { cx: '6.75', cy: '17.125', r: '1.5' } }),
              h('circle', { attrs: { cx: '15.75', cy: '17.125', r: '1.5' } })
            ])
          ])
        );
        break;
      }
      case 55: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 424.98 424.98' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M241.395 282.304c-1.587-1.738-3.595-3.038-5.67-4.121-4.518-2.356-9.459-3.785-14.365-5.075v38.016c7.963-.9 17.105-3.79 21.286-11.224 1.996-3.551 2.393-7.914 1.58-11.867-.441-2.142-1.352-4.108-2.831-5.729z'
              }
            }),
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M242.604 299.973l.042-.073a4.74 4.74 0 00-.042.073zM184.009 221.532c-1.369 1.999-2.228 4.27-2.465 6.684-.237 2.419-.104 5.11.815 7.387.875 2.17 2.708 3.772 4.6 5.062 2.123 1.444 4.458 2.572 6.836 3.528 1.995.803 4.239 1.571 6.658 2.313v-34.4c-6.111 1.304-12.788 4.088-16.444 9.426zM242.804 299.619c-.05.089-.104.182-.157.28.062-.114.111-.198.157-.28zM243.004 299.263c.013-.024.015-.026 0 0z'
              }
            }),
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M234.753 92.469c32.329-27.158 53.931-88.341 40.637-91.017-17.664-3.557-56.022 12.04-74.562 14.788-26.296 3.175-54.936-28.515-71.012-10.851-13.071 14.362 9.371 66.592 44.482 89.346-104.752 51.484-251.988 309.938 4.873 328.691 355.411 25.949 177.444-280.787 55.582-330.957zm30.523 203.829c-1.093 10.076-6.433 19.188-14.415 25.374-8.428 6.532-18.999 9.57-29.502 10.421v11.133c0 2.979-1.301 5.86-3.531 7.832-3.065 2.712-7.569 3.381-11.289 1.667-3.673-1.69-6.086-5.457-6.086-9.499v-12.168a68.538 68.538 0 01-5.356-1.234c-9.816-2.697-18.921-7.954-25.572-15.732-3.313-3.877-6.014-8.276-7.882-13.025a47.162 47.162 0 01-1.304-3.783c-.345-1.157-.701-2.333-.824-3.539a10.46 10.46 0 011.137-5.889c1.938-3.707 6.022-5.946 10.192-5.574 4.104.364 7.701 3.212 8.993 7.124.398 1.205.668 2.44 1.115 3.632a23.292 23.292 0 001.607 3.431 26.647 26.647 0 004.59 5.875c3.694 3.559 8.399 5.872 13.304 7.248V268.23c-9.591-2.483-19.491-5.69-27.411-11.848-3.849-2.994-7.115-6.714-9.254-11.117-2.257-4.647-3.192-9.824-3.23-14.966-.039-5.221.953-10.396 3.131-15.153 2.04-4.454 4.977-8.453 8.578-11.768 7.7-7.087 17.928-11.04 28.187-12.492v-11.557c0-2.978 1.301-5.86 3.531-7.832 3.066-2.711 7.568-3.381 11.289-1.667 3.672 1.691 6.086 5.457 6.086 9.499v11.494c1.367.172 2.73.378 4.086.624 10.074 1.823 19.927 5.983 27.294 13.246a39.888 39.888 0 018.356 12.009 38.31 38.31 0 011.477 3.824c.396 1.213.794 2.462.983 3.728a10.467 10.467 0 01-.871 5.958c-1.772 3.788-5.746 6.2-9.927 6.021-4.108-.179-7.83-2.854-9.301-6.694-.438-1.142-.657-2.351-1.104-3.49a18.419 18.419 0 00-1.708-3.292c-1.308-2.02-3.003-3.752-4.938-5.179-4.19-3.094-9.272-4.706-14.35-5.607v39.582c6.035 1.445 12.075 3.021 17.857 5.301 8.739 3.446 17.02 8.73 21.79 17.062-.74-1.298-1.46-2.563.025.043 1.458 2.56.762 1.34.03.057 3.795 6.688 5.042 14.685 4.217 22.282z'
              }
            }),
            h('path', {
              attrs: {
                fill: 'currentColor',
                d: 'M242.493 300.169l-.156.278c.036-.063.09-.158.156-.278z'
              }
            })
          ])
        );
        break;
      }
      case 56: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 512 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M376 33c-60.659 0-99.595 42.012-120 79.849C235.595 75.011 196.659 33 136 33 59.037 33 0 95.446 0 178.268c0 21.61 4.327 41.561 12.294 60.732h114.434l25.854-51.709c5.098-10.166 21.738-10.166 26.836 0L226 280.456l16.582-33.164c5.098-10.166 21.738-10.166 26.836 0L286 280.456l46.582-93.164c5.098-10.166 21.738-10.166 26.836 0L385.272 239h114.434C507.673 219.829 512 199.878 512 178.268 512 95.446 452.963 33 376 33z'
              }
            }),
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M376 269a15.006 15.006 0 01-13.418-8.291L346 227.545l-46.582 93.164A15.006 15.006 0 01286 329a15.006 15.006 0 01-13.418-8.291L256 287.545l-16.582 33.164c-5.098 10.166-21.738 10.166-26.836 0L166 227.545l-16.582 33.164A15.006 15.006 0 01136 269H28.037c30.873 48.574 86.474 94.713 156.024 153.413 19.526 16.479 40.298 34.014 62.109 52.925 2.827 2.446 6.328 3.662 9.829 3.662s7.002-1.216 9.829-3.662c21.812-18.911 42.583-36.445 62.109-52.925 69.551-58.7 125.151-104.839 156.024-153.413H376z'
              }
            })
          ])
        );
        break;
      }
      case 57: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 512 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M426 481.997h-32.435l-38.704-97.652-42.337-211.223-18.191-90.755a45.667 45.667 0 009.055-27.342c0-25.315-20.596-45.91-45.912-45.91s-45.912 20.596-45.912 45.91a45.666 45.666 0 009.091 27.393c-4.567 22.777-18.215 90.85-18.255 91.081l-42.26 210.845-38.705 97.652H86c-8.284 0-15 6.716-15 15s6.716 15 15 15h45.537c.028 0 .056.004.084.004.035 0 .069-.004.104-.004h251.55c.035 0 .069.004.104.004.028 0 .056-.004.084-.004H426c8.284 0 15-6.716 15-15s-6.716-14.999-15-14.999zM315.367 339.954l-37.403-40.308 24.116-25.988 13.287 66.296zm-9.331 34.049h-97.071l48.535-52.304 48.536 52.304zM267.247 99.878l12.266 61.196h-44.025l12.264-61.185a45.906 45.906 0 009.725 1.046c3.352 0 6.619-.371 9.77-1.057zm-37.772 91.196h56.051l9.283 46.315-37.309 40.206-37.308-40.205 9.283-46.316zm-16.553 82.586l24.115 25.987-37.402 40.306 13.287-66.293zM184.62 404.002h145.762l30.914 77.994h-207.59l30.914-77.994z'
              }
            }),
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M178.762 122.273c2.914 0 5.86-.848 8.448-2.616 6.84-4.673 8.597-14.007 3.923-20.847-8.832-12.926-13.499-28.066-13.499-43.785 0-6.818.887-13.594 2.637-20.139 2.14-8.003-2.614-16.225-10.617-18.365-8.003-2.136-16.226 2.615-18.365 10.617a108.025 108.025 0 00-3.655 27.887c0 21.783 6.477 42.775 18.729 60.708 2.906 4.253 7.611 6.54 12.399 6.54zM127.682 157.104c2.914 0 5.86-.848 8.448-2.616 6.84-4.673 8.597-14.007 3.923-20.847-15.859-23.211-24.242-50.397-24.242-78.616 0-12.236 1.593-24.398 4.734-36.147 2.14-8.003-2.613-16.225-10.616-18.365-8.003-2.139-16.226 2.613-18.365 10.616a170.005 170.005 0 00-5.753 43.896c0 34.283 10.191 67.32 29.472 95.539 2.905 4.252 7.61 6.54 12.399 6.54zM324.027 119.129a14.924 14.924 0 008.353 2.551c4.828 0 9.568-2.327 12.464-6.635 11.945-17.777 18.26-38.532 18.26-60.021 0-9.291-1.19-18.529-3.539-27.459-2.108-8.012-10.314-12.796-18.322-10.691-8.012 2.107-12.799 10.31-10.691 18.322a77.98 77.98 0 012.553 19.828c0 15.507-4.551 30.476-13.16 43.289-4.622 6.877-2.794 16.196 4.082 20.816zM375.377 153.566a14.921 14.921 0 008.352 2.551c4.828 0 9.568-2.327 12.464-6.635 18.798-27.974 28.733-60.637 28.733-94.457 0-14.622-1.874-29.163-5.569-43.219-2.107-8.013-10.317-12.803-18.32-10.693-8.013 2.107-12.8 10.309-10.693 18.321a140.052 140.052 0 014.583 35.591c0 27.839-8.173 54.716-23.634 77.725-4.62 6.876-2.792 16.196 4.084 20.816z'
              }
            })
          ])
        );
        break;
      }
      case 58: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 792 792' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M521.806 792s71.889 0 71.889-71.997V71.997C593.694 0 521.806 0 521.806 0H270.194s-71.889 0-71.889 71.997v648.006C198.306 792 270.194 792 270.194 792h251.612zM396 762.022c-19.841 0-35.944-16.104-35.944-35.944 0-19.842 16.103-35.944 35.944-35.944 19.842 0 35.944 16.103 35.944 35.944S415.842 762.022 396 762.022zM342.083 43.888c0-4.457 2.121-7.944 4.78-7.944h98.272c2.624 0 4.781 3.559 4.781 7.944v2.121c0 4.457-2.157 7.944-4.781 7.944h-98.272c-2.624 0-4.78-3.559-4.78-7.944v-2.121zM234.25 89.861h323.5v575.111h-323.5V89.861z'
              }
            })
          ])
        );
        break;
      }
      case 59: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 320 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z'
              }
            })
          ])
        );
        break;
      }
      case 60: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 576 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M280.37 148.26L96 300.11V464a16 16 0 0016 16l112.06-.29a16 16 0 0015.92-16V368a16 16 0 0116-16h64a16 16 0 0116 16v95.64a16 16 0 0016 16.05L464 480a16 16 0 0016-16V300L295.67 148.26a12.19 12.19 0 00-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 00-12-12h-56a12 12 0 00-12 12v72.61L318.47 43a48 48 0 00-61 0L4.34 251.47a12 12 0 00-1.6 16.9l25.5 31A12 12 0 0045.15 301l235.22-193.74a12.19 12.19 0 0115.3 0L530.9 301a12 12 0 0016.9-1.6l25.5-31a12 12 0 00-1.7-16.93z'
              }
            })
          ])
        );
        break;
      }
      case 61: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 512 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M0 320c0 27.77 18 53.37 48 74.33V330c-18.85-12-35.4-25.36-48-40.38zm256 32c141.33 0 256-64.44 256-144S397.33 64 256 64 0 128.44 0 208s114.67 144 256 144zM80 412.51c27.09 12.89 59.66 22.81 96 28.8V377c-35.39-6-67.81-15.88-96-29zm384-18.18c30.05-21 48-46.56 48-74.33v-30.37c-12.6 15-29.15 28.37-48 40.38zm-128 47c36.34-6 68.91-15.91 96-28.8V348c-28.19 13.12-60.61 23-96 29zM208 381.2v64.09c15.62 1.51 31.49 2.71 48 2.71s32.38-1.2 48-2.71V381.2a477.2 477.2 0 01-48 2.8 477.2 477.2 0 01-48-2.8z'
              }
            })
          ])
        );
        break;
      }
      case 62: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 512 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z'
              }
            })
          ])
        );
        break;
      }
      case 63: {
        children.push(
          h('svg', { attrs: { ...attrs, viewBox: '0 0 512 512' } }, [
            h('path', {
              attrs: {
                fill: 'currentColor',
                d:
                  'M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z'
              }
            })
          ])
        );
        break;
      }
      default:
        children.push(h('span', this.$t('white-label.components.sector.unavailable')));
    }

    return h('div', { class: 'c-sector-icon' }, children);
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-sector-icon';
</style>
